<div class="recorder_modal create-recorder-heatmap confirmation_modal">
  <p class="recorder_modal_title" *ngIf="header">{{ header }}</p>
  <div class="recorder_modal_text" *ngIf="content">{{ content }}</div>
  <div class="button_container">
    <ng-container>
      <button
        mat-raised-button
        class="primary"
        (click)="this.dialogRef.close()"
        #btnFocus="matButton"
        [autofocus]="btnFocus.focus()"
      >
        {{ "words.go_back" | translate }}
      </button>
    </ng-container>
  </div>
</div>
